import { render, staticRenderFns } from "./TheLeagueUser.vue?vue&type=template&id=479f66df&scoped=true"
import script from "./TheLeagueUser.vue?vue&type=script&lang=ts"
export * from "./TheLeagueUser.vue?vue&type=script&lang=ts"
import style0 from "./TheLeagueUser.vue?vue&type=style&index=0&id=479f66df&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479f66df",
  null
  
)

export default component.exports